import React from 'react';
import { injectIntl, useIntl } from 'react-intl';
import { Col, Row, UncontrolledTooltip } from 'reactstrap';
import IntlMessage from '../../../../helpers/intlMessage';
import { IntlProvider } from 'react-intl';
import { AppLocale } from '../../../../lang';
import { useSelector } from 'react-redux';
import Paragrafo from './Paragrafo';

function Card({ item, icone, etapa, openModal }) {
	const lang = useSelector((state) => state.commonReducer.lang);
	const currentAppLocale = (AppLocale)[lang];
	const intl = useIntl()
	return (
		<IntlProvider locale={currentAppLocale ? currentAppLocale.locale : lang} messages={currentAppLocale ? currentAppLocale.messages : ''}>
			<Row>
				<Col>
					<p style={{ fontSize: '16px', fontWeight: 600, marginBottom: '2px' }}>
						{item.nrBloco}
					</p>
					<Paragrafo
						id={`material_${item.id}`}
						title={<IntlMessage id='dashboards.examDetail.Material' />}
						text={item.nomeMaterial}
					/>
					<p
						id={`paciente_${item.id}`}
						style={{ fontSize: '14px', marginBottom: '2px' }}
					>
						<strong><IntlMessage id='dashboards.disposalMaterials.patient' />: </strong>
						{item.nomePaciente}
						<UncontrolledTooltip placement='top' target={`paciente_${item.id}`}>
							{item.nomePaciente}
						</UncontrolledTooltip>
					</p>
					{item.pacienteNomeSocial &&
						<p
							id={`nomesocial_${item.id}`}
							style={{ fontSize: '14px', marginBottom: '2px' }}
						>
							<strong><IntlMessage id='dashboards.general.socialName' />: </strong>
							{item.pacienteNomeSocial}
							<UncontrolledTooltip placement='top' target={`nomesocial_${item.id}`}>
								{item.pacienteNomeSocial}
							</UncontrolledTooltip>
						</p>}

					<Paragrafo
						id={`coloracao_${item.id}`}
						title={`${intl.formatMessage({ id: 'general.requestsPanel.colorations' })}`}
						text={item.coloracao}
					/>
				</Col>
				<div className='menu-right'>
					<div>
						<br></br>
						{(item.nConformidade === 'S' || item.existeNConformidade < 2) && (
							<div >
								<p
									id={`nao_conformidade${item.id}`}
									style={{ fontSize: '9px', marginBottom: '5px', marginTop: '5px' }}
									className='badge badge-danger nao-conformidade'
								>
									<IntlMessage id='dashboards.general.nonCompliance' />
								</p>
							</div>
						)}
						<p
							id={`data_atualizacao_${item.id}`}
							style={{ fontSize: '10px', marginBottom: '5px', marginTop: '5px' }}
							className='badge badge-info'
						>
							{item.dataAtualizacao}
						</p>
						<UncontrolledTooltip placement='top' target={`data_atualizacao_${item.id}`}>
							{`${intl.formatMessage({ id: 'dashboards.cytology.updateDate' })}`}
						</UncontrolledTooltip>

						<div className='menu-card-right'>
							<i
								className='fas fa-exclamation-circle'
								style={{ color: `${item.nConformidade === 'S' ? 'red' : ''}` }}
								title={`${intl.formatMessage({ id: 'dashboards.general.nonCompliance' })}`}
								onClick={() => openModal(item.id, etapa, 'naoconformidade')}
							></i>
							<i
								className={`${icone} fa-2x`}
								style={{
									color: '#3076a8',
									fontSize: '1.5em'
								}}
							></i>
						</div>

					</div>
				</div>
			</Row>
		</IntlProvider>
	);
}

export default injectIntl(Card);



// WEBPACK FOOTER //
// ./src/pages/histologia/inclusao/Card/index.js